import { render, staticRenderFns } from "./ConfirmationFields.vue?vue&type=template&id=6478d710&scoped=true"
import script from "./ConfirmationFields.vue?vue&type=script&lang=js"
export * from "./ConfirmationFields.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationFields.vue?vue&type=style&index=0&id=6478d710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6478d710",
  null
  
)

export default component.exports